import React from 'react';
import { ctaLabel } from '../data/content';
interface CTAButtonProps {
  label?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  label = ctaLabel,
  href = '#comprar',
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-cta bg-pink px-6 py-4 text-center text-base font-extrabold text-surface shadow-cta focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink sm:text-[17px] ${className}`} data-id="element-56" data-mp="2kzzi4vr3lkvf">
      {label}
    </a>;
}